module.exports = __webpack_public_path__ + "static/img/icon-insurance-04.c9cd413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-insurance-04.png
// module id = 9YQL
// module chunks = 1